// tslint:disable:max-line-length

import React from 'react';

export const ActionCloseSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="12.4,4.6 11.4,3.6 8,6.9 4.6,3.6 3.6,4.6 6.9,8 3.6,11.4 4.6,12.4 8,9.1 11.4,12.4 12.4,11.4 9.1,8" />
    </svg>
  );
};
